import { LoadingButton } from '@mui/lab';
import { FormControl, IconButton, InputLabel, MenuItem, Select, TextField, Typography } from '@mui/material'
import Grid from '@mui/material/Unstable_Grid2/Grid2'
import { ChangeEvent, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import socket, { IResponse } from '../../socket';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import axios from 'axios';

export default function NewChannel() {
    const { t } = useTranslation();
    const [type, setType] = useState('caltural');
    const [lang, setLang] = useState('fa');
    const [loading, setLoading] = useState(false);
    const [txtImage, setTxtImage] = useState('');
    const navigate = useNavigate()

    const txtName = useRef<HTMLInputElement>();
    const txtDescription = useRef<HTMLInputElement>();
    const fileImage = useRef<HTMLInputElement>(null);

    const handleChangeType = (event: any) => {
        setType(event.target.value)
    }

    const handleChangeLang = (event: any) => {
        setLang(event.target.value)
    }

    const handleCreate = () => {
        setLoading(true);
        const data = {
            name: txtName.current!.value,
            image: txtImage,
            description: txtDescription.current!.value,
            type,
            lang,
        }
        socket.emit('channel:create', data, (data: IResponse<null>) => {
            setLoading(false);
            if (data.success) {
                navigate('/channel');
            }
        });
    }

    const handleClickUploadFile = () => {
        fileImage.current!.click();
    }

    const handleChangeFile = (event: ChangeEvent<HTMLInputElement>) => {
        const files = event.target.files;
        if (files && files.length === 1) {
            const file = files[0];
            setLoading(true);
            const formData = new FormData();
            formData.append('file', files[0]);
            axios({
                url: `${process.env.REACT_APP_BASE_URL ?? 'http://localhost:5000/api/'}/upload`,
                method: 'POST',
                data: formData,
                headers: {
                    Authorization: localStorage.getItem('admin_rezvan_token')
                }
            }).then((res) => {
                setLoading(false);
                if (res.data.status) {
                    setTxtImage(res.data.result);
                } else {
                    // TODO: show error message
                }
            }).catch((err) => {
                setLoading(false);
            });

        }
    };

    return (
        <>
            <Typography className="m-4">{t('new_channel')}</Typography>
            <Grid container className='mx-4' spacing={2}>
                <Grid xs={12} md={6}>
                    <TextField inputRef={txtName} fullWidth label={t('channel_name')} />
                </Grid>
                <Grid className="flex flex-row space-x-2 space-x-reverse" xs={12} md={6}>
                    <TextField value={txtImage} className='grow' label={t('image_url')} disabled />
                    <input type='file' className='hidden' ref={fileImage} onChange={handleChangeFile} />
                    <IconButton color='primary' onClick={handleClickUploadFile}>
                        <CloudUploadIcon />
                    </IconButton>
                </Grid>
                <Grid xs={12} md={6}>
                    <FormControl fullWidth>
                        <InputLabel>{t('channel_type')}</InputLabel>
                        <Select
                            value={type}
                            label={t('channel_type')}
                            onChange={handleChangeType}
                        >
                            <MenuItem value='caltural'>{t('caltural')}</MenuItem>
                            <MenuItem value='news'>{t('news')}</MenuItem>
                        </Select>
                    </FormControl>
                </Grid>
                <Grid xs={12} md={6}>
                    <FormControl fullWidth>
                        <InputLabel>{t('language')}</InputLabel>
                        <Select
                            value={lang}
                            label={t('language')}
                            onChange={handleChangeLang}
                        >
                            <MenuItem value='fa'>{t('fa')}</MenuItem>
                            <MenuItem value='en'>{t('en')}</MenuItem>
                            <MenuItem value='ar'>{t('ar')}</MenuItem>
                            <MenuItem value='ur'>{t('ur')}</MenuItem>
                        </Select>
                    </FormControl>
                </Grid>
                <Grid xs={12}>
                    <TextField inputRef={txtDescription} fullWidth minRows={5} multiline placeholder={t('first_channel_message_title')} />
                </Grid>
                <Grid xs={12}>
                    <LoadingButton loading={loading} onClick={handleCreate} variant='contained'>{t('create')}</LoadingButton>
                </Grid>
            </Grid>
        </>
    )
}
